export default __webpack_public_path__ + "static/media/cross.c2bc1164.png";